import * as React from 'react';
import { MainArea } from './mainArea';
import { MainModel } from './../Models/mainModel';
import { loadServicesPage } from './../Actions/servicesActions';
import { HeaderImageComponent } from './headerImage';
import * as renderHTML from 'react-render-html';

declare function require(path: string);
declare var $;

//export interface LayoutProps {
//    children?: React.ReactNode;
//}

export class Services extends React.Component<MainModel, MainModel> {

    public componentDidMount() {
        this.props.dispatch(loadServicesPage());
    }

    public render() {

        return this.props.ServicesModel == null ?
            <div className="main-loading-bg" ></div> :
            <div>
                <HeaderImageComponent Image={this.props.ServicesModel.HeaderImage == null ? null : this.props.ServicesModel.HeaderImage.Image} TitleText={this.props.ServicesModel.HeaderImage == null ? null : this.props.ServicesModel.HeaderImage.TitleText} PageGroupID={this.props.ServicesModel.PageGroupID} />
                { /* start setup area */}
                <section id="venueArea" className="text-center">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-4 col-sm-6">
                                <h3><i className="fa fa-desktop"></i> {this.props.ServicesModel.EnterpriseApplicationsTitle}</h3>
                                {renderHTML(this.props.ServicesModel.EnterpriseApplicationsDescription)}
                            </div>

                            <div className="col-md-4 col-sm-6">
                                <h3><i className="fa fa-html5"></i> {this.props.ServicesModel.WebApplicationsTitle}</h3>
                                {renderHTML(this.props.ServicesModel.WebApplicationsDescription)}
                            </div>

                            <div className="col-md-4 col-sm-6">
                                <h3><i className="fa fa-mobile"></i> {this.props.ServicesModel.MobileApplicationsTitle} </h3>
                                {renderHTML(this.props.ServicesModel.MobileApplicationsDescription)}
                            </div>

                            <div className="col-md-4 col-sm-6">
                                <h3><i className="fa fa-hand-o-up"></i> {this.props.ServicesModel.WebDesignTitle}</h3>
                                {renderHTML(this.props.ServicesModel.WebDesignDescription)}
                            </div>

                            <div className="col-md-4 col-sm-6">
                                <h3><i className="fa fa-wrench"></i> {this.props.ServicesModel.QualityAssuranceTitle}</h3>
                                {renderHTML(this.props.ServicesModel.QualityAssuranceDescription)}
                            </div>
                        </div>
                    </div>
                </section>
                { /* end setup area */}
            </div>;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/Components/services.tsx